/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { useEffect, useState } from "preact/compat";
import { Lang } from "@adobe-commerce/elsie/i18n";
import { events } from "@adobe-commerce/event-bus";

export const DEFAULT_LOCALE: Lang = "en_US";

export function useLocale(): Lang {
  const [locale, setLocale] = useState<string>(events.lastPayload("locale") || DEFAULT_LOCALE);

  useEffect(() => {
    const subscription = events.on("locale", setLocale);
    return () => subscription?.off();
  }, [locale]);

  return locale as Lang
}
